"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_MESSAGE_CONTENT_UPLOAD_FAILED = exports.SEND_MESSAGE_FAILED = exports.SEND_MESSAGE_SUCCEEDED = exports.SEND_MESSAGE_REQUESTED = void 0;
const uuid_1 = require("uuid");
const service_1 = __importDefault(require("../../services/chats/service"));
const CachingDataService_1 = __importStar(require("../../services/data/CachingDataService"));
const constants_1 = require("../../constants");
const Stopwatch_1 = __importDefault(require("../../utils/Stopwatch"));
const Alert_1 = require("../../components/modals/Alert");
const chatFunctions = __importStar(require("../../domain/model/chats"));
exports.SEND_MESSAGE_REQUESTED = "SEND_MESSAGE_REQUESTED";
exports.SEND_MESSAGE_SUCCEEDED = "SEND_MESSAGE_SUCCEEDED";
exports.SEND_MESSAGE_FAILED = "SEND_MESSAGE_FAILED";
exports.SEND_MESSAGE_CONTENT_UPLOAD_FAILED = "SEND_MESSAGE_CONTENT_UPLOAD_FAILED";
function default_1(chat, sendMessageContent, repliesTo) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        // Don't send a direct message if you block the recipient
        if (chatFunctions.isDirectChat(chat)) {
            const blockedUsers = getState().chatsState.blockedUsers;
            if (blockedUsers.includes(chat.them)) {
                Alert_1.alertDialog({
                    title: "Message not sent",
                    text: "You have blocked this user - you must unblock them before sending a message"
                });
                return;
            }
        }
        const timer = Stopwatch_1.default.startNew();
        const clientMessageId = uuid_1.v1().toString();
        // If the "send message content" is media the message itself will contain
        // meta info about the media and the data will be uploaded separately in parallel
        const content = convertContent(sendMessageContent);
        // Start uploading the media data
        let uploadContentTask = null;
        if ("id" in content && "data" in sendMessageContent) {
            uploadContentTask = CachingDataService_1.default.putData(sendMessageContent.kind === "media" ? CachingDataService_1.DataSource.MediaMessage : CachingDataService_1.DataSource.FileMessage, content.id, sendMessageContent.data);
        }
        // Dispatch the message requested event - this will put the message in the chat
        const request = {
            chat,
            clientMessageId,
            content,
            repliesTo
        };
        const requestEvent = {
            type: exports.SEND_MESSAGE_REQUESTED,
            payload: request
        };
        dispatch(requestEvent);
        // We can't send messages to a new group until the group has been confirmed at which point we will receive the chatId.
        // So we only signal the 'requestEvent', the reducer will then add the message to the 'unconfirmedMessages' array for
        // the chat and those messages will be sent once the chat is confirmed.
        if (chat.kind === constants_1.UNCONFIRMED_GROUP_CHAT) {
            return;
        }
        // Wait for the media data to finish uploading
        if (uploadContentTask && !(yield uploadContentTask)) {
            dispatch({ type: exports.SEND_MESSAGE_CONTENT_UPLOAD_FAILED });
            return;
        }
        const me = getState().usersState.me;
        // Send the message to the IC
        const response = chat.kind === constants_1.UNCONFIRMED_DIRECT_CHAT || (chat.kind === constants_1.CONFIRMED_DIRECT_CHAT && sendMessageContent.kind === "cycles")
            ? yield service_1.default.sendDirectMessage(chat.them, me.username, clientMessageId, content, repliesTo)
            : yield service_1.default.sendMessage(chat.chatId, me.username, clientMessageId, content, repliesTo);
        if (response.kind !== "success") {
            // Dispatch a failed event
            dispatch({
                type: exports.SEND_MESSAGE_FAILED,
                payload: {
                    chatId: chat.chatId,
                    clientMessageId
                },
                httpError: response.kind === "httpError" ? response : undefined
            });
            if (response.kind !== "httpError") {
                let text;
                switch (response.kind) {
                    case "userNotFound":
                        text = "User not found";
                        break;
                    case "recipientNotFound":
                        text = "Recipient not found";
                        break;
                    case "chatNotFound":
                        text = "Chat not found";
                        break;
                    case "balanceExceeded":
                        text = "Balance exceeded";
                        break;
                    case "senderBlocked":
                        text = "You are blocked from sending messages to this user";
                        break;
                    case "recipientBlocked":
                        text = "You have blocked this user - you must unblock them before sending a message";
                        break;
                }
                Alert_1.alertDialog({
                    title: "Message not sent",
                    text
                });
            }
            return;
        }
        // Dispatch a succeeded event
        {
            const myUserId = me.userId;
            const message = {
                kind: "local",
                id: response.result.messageId,
                clientMessageId,
                date: response.result.date,
                sender: myUserId,
                content,
                repliesTo
            };
            const chat = response.result.chat;
            chat.messages.push(message);
            dispatch({
                type: exports.SEND_MESSAGE_SUCCEEDED,
                payload: {
                    request,
                    chat,
                    durationMs: timer.getElapsedMs()
                }
            });
        }
    });
}
exports.default = default_1;
function convertContent(sendMessageContent) {
    switch (sendMessageContent.kind) {
        case "media":
            return {
                kind: sendMessageContent.kind,
                caption: sendMessageContent.caption,
                mimeType: sendMessageContent.mimeType,
                width: sendMessageContent.width,
                height: sendMessageContent.height,
                id: uuid_1.v1().toString(),
                size: sendMessageContent.data.length,
                chunkSize: constants_1.CHUNK_SIZE_BYTES,
                blobUrl: sendMessageContent.blobUrl,
                thumbnailData: sendMessageContent.thumbnailData,
                blobDeleted: false
            };
        case "file":
            return {
                kind: sendMessageContent.kind,
                caption: sendMessageContent.caption,
                name: sendMessageContent.name,
                mimeType: sendMessageContent.mimeType,
                id: uuid_1.v1().toString(),
                size: sendMessageContent.data.length,
                chunkSize: constants_1.CHUNK_SIZE_BYTES,
                blobDeleted: false
            };
        case "text":
        case "cycles":
            return sendMessageContent;
        default:
            throw Error("Unrecognised content type");
    }
}
